module.exports = __webpack_public_path__ + "static/media/Chat_with_rider.aab228aa.png";